// extracted by mini-css-extract-plugin
export var linkSvg = "style-module--linkSvg--2ipl3";